import { Injectable } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { WidgetRegistryService } from '@frontend/sports/widget/core/feature';
import { WidgetTabBarMapperRegistryService } from '@frontend/sports/widget/feature/tab-bar';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { TabbedGridNavigationService } from './tabbed-grid-navigation.service';
import { TabbedGridWidgetComponent } from './tabbed-grid-widget.component';

@Injectable()
export class WidgetRegistrationService implements OnFeatureInit {
    constructor(
        private registry: WidgetRegistryService,
        private navigationRegistry: WidgetTabBarMapperRegistryService,
        private navigationMapper: TabbedGridNavigationService,
    ) {}

    onFeatureInit(): void {
        this.registry.registerLazy(WidgetType.TabbedGrid, TabbedGridWidgetComponent);
        this.navigationRegistry.register(WidgetType.TabbedGrid, this.navigationMapper);
    }
}
